import styled from 'styled-components'

export const Small = styled.small`
  font-size: 0.75em;
  margin-top: 20px;
  display: block;
  line-height: 1.3;
`

export const Note = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  color: var(--text-color);
  font-size: 0.75em;
  line-height: 1.2;
  width: 100px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 0.65em;
    width: 80px;
  }
`

export const ContentWidth = styled.div`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: calc(100% - 30px);
    margin: 0 15px;
  }
`

export const GridLine = styled.line`
  stroke: ${({ theme }) => theme.greyLight};
  stroke-width: 1px;
`
